export const setCertificado = async ({ commit }, hasCertificado) => {
    commit('SET_CERTIFICADO', hasCertificado);
};
